import { isRelationManyValue } from '@varos/research-sdk';
import { assert } from '@varos/util-typescript';
import React, { useContext } from 'react';
import { ValueContainerProps } from './valueProps';
import { ReportingContainerBaseConfig } from '../../base';
import { ValueController } from './valueInterface';
import { RelationOneValueContainerProps } from './relation/one';
import { RelationManyValueContainerProps } from './relation';

export function createValueContainer(
    config: ReportingContainerBaseConfig & {
        Container: {
            Relation: {
                One: React.FC<RelationOneValueContainerProps>;
                Many: React.FC<RelationManyValueContainerProps>;
            };
        };
    },
    controller: ValueController
): React.FC<ValueContainerProps> {
    const {
        context: { useContext },
        Container: {
            Relation: { One: RelationOneContainer, Many: RelationManyContainer },
        },
    } = config;

    return ({ as: View, ...containerProps }) => {
        if (
            containerProps.item.property.type === 'relation' &&
            containerProps.item.property.config.cardinality === 'one'
        ) {
            return <RelationOneContainer as={View} {...containerProps} />;
        }
        if (
            containerProps.item.property.type === 'relation' &&
            containerProps.item.property.config.cardinality === 'many'
        ) {
            assert(
                isRelationManyValue(containerProps.item.value),
                'expected relation many value'
            );
            return (
                <RelationManyContainer
                    as={View}
                    {...containerProps}
                    item={{
                        ...containerProps.item,
                        value: containerProps.item.value as string[],
                    }}
                />
            );
        }
        const context = useContext();
        const props = controller.useProps(context, containerProps.item, {});
        return <View {...props} />;
    };
}
